import { ButtonHTMLAttributes } from 'react';
import { Container } from './styles';

export const Button = ({ children, ...rest}: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <Container {...rest}>
      {children}
    </Container>
  )
}